import { useRouter } from "next/router"
import React, { useEffect } from "react"
import { useSelector } from "react-redux"
import styled from "styled-components"
import ContentInner from "~/components/atoms/ContentInner"
import { useGlobal } from "~/composable/useGlobal"
import { CompanyType } from "~/model/Company"
import { selectAuthorization } from "~/slices/authorizationSlice"

export default function HeaderTitle() {
  const authorization = useSelector(selectAuthorization)
  const { title } = useGlobal()
  const router = useRouter()

  const showLedger = router.pathname.includes("/contracts/ledger/")

  return (
    <Content>
      <ContentInner>
        <div className="title-bar">
          <div>{title}</div>
          {(authorization.user?.company?.type === CompanyType.MANAGEMENT ||
            authorization.user?.company?.type === CompanyType.AGENT ||
            router.pathname.split("/")?.[1] === "authentication") && (
            <div className="title-guild">
              <div className="guild-text">よくある質問</div>
              <div className="button-link">
                <a
                  href="https://pm-ambition-cloud.s3.ap-northeast-1.amazonaws.com/pdf/faq_branch_top.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  支店について
                </a>
              </div>
              <div className="button-link">
                <a
                  href="https://pm-ambition-cloud.s3.ap-northeast-1.amazonaws.com/pdf/faq_takkenshi_top.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  宅建士について
                </a>
              </div>
            </div>
          )}
          {(authorization.user?.company?.type === CompanyType.MANAGEMENT && router.pathname.split("/")?.[1] === 'contracts') && (
            <div className="toggle-button">
              <span className="toggle-text">台帳管理表示</span>
              <div
                className={`toggle-switch ${showLedger ? "on" : "off"}`}
                onClick={() => router.push({ pathname: showLedger ? "/contracts/progress/" : "/contracts/ledger/progress/" })}
              >
                <div className="toggle-circle"></div>
              </div>
            </div>
          )}
        </div>
      </ContentInner>
    </Content>
  )
}

const Content = styled.div`
  border-bottom: 1px solid #efefef;
  height: 45px;
  line-height: 45px;
  font-size: 18px;
  font-weight: bold;
  color: #222222;
  padding: 0 20px;
  /* @media screen and (max-width: 415px) {
    width: 90%;
    margin: 0 auto;
  } */

  .title-bar {
    display: flex;
    align-items: center;
    .title-guild {
      height: 30px;
      display: flex;
      font-size: 16px;
      align-items: center;
      line-height: unset;
      margin-left: 100px;

      .guild-text {
        margin-right: 16px;
        font-weight: 600;
      }

      .button-link {
        padding: 6px 10px 4px;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #888888;
        color: #fff;
        font-size: 14px;
        font-weight: 600;
        border-radius: 3px;
        margin-left: 8px;
        cursor: pointer;

        a {
          color: #fff !important;
        }
      }
    }
    .toggle-button {
      margin-left: auto;
      font-size: 14px;
      font-weight: bold;
      color: #777777;
      display: flex;
      gap: 8px;
      align-items: center;

      .toggle-text {
        font-size: 14px;
        color: #333;
        font-weight: 500;
      }
      .toggle-switch {
        width: 42px;
        height: 22px;
        border-radius: 20px;
        background-color: #ccc;
        position: relative;
        cursor: pointer;
        transition: background-color 0.3s ease;
      }

      .toggle-switch.on {
        background-color: #4caf50;
      }

      .toggle-circle {
        position: absolute;
        top: 2px;
        left: 2px;
        width: 18px;
        height: 18px;
        background-color: #fff;
        border-radius: 50%;
        transition: left 0.3s ease;
      }

      .toggle-switch.on .toggle-circle {
        left: 22px;
      }
    }
  }
`
